<template>
  <div>

    <Drawer v-model="dialog" :mask-closable="false" width="880" @on-close="closeDialog">
      <div slot="header"><strong>Approve Invoice</strong></div>
      <div slot="close"><Icon size="20" class="close-icon" type="md-close" @click="closeDialog"/></div>
      <div class="drawer-body">
        <charges-summary :clientInvoiceId="clientInvoiceId" ref="charges-summary-comp"/>
      </div>
      <div class="drawer-footer">
        <Button type="primary" size="large" @click="confirmAcceptAction" :loading="loading">APPROVE INVOICE</Button>
        <Button class="close-btn" size="large" @click="closeDialog">CLOSE</Button>
      </div>
    </Drawer>

  </div>
</template>

<script>
import {Constants} from "../../../Constants/Constant";
import moment from 'moment';
import ChargesSummary from "../ChargesSummary";
import updateRecord from '../../../mixins/updateRecord';
import {GET_CLIENT_INVOICE_WHILE_ACCEPT, GET_LAST_CLIENT_INVOICE} from "../../../graphql/queries/clientInvoices";
import {incrementClientInvoiceNumber} from "../Settings";
let user = JSON.parse(localStorage.tatkalorri).userObj.user;
export default {
  name: "AcceptAction",
  components: {ChargesSummary},
  props: ['dialog', 'clientInvoiceId'],
  mixins: [updateRecord],
  apollo:{
    clientInvoices: {
      query: GET_CLIENT_INVOICE_WHILE_ACCEPT,
      fetchPolicy: 'network-only',
      skip () {return !this.dialog},
      variables(){ return{ id: this.clientInvoiceId } },
      result ({data}) { this.clientInvoice = data.clientInvoices[0]; }
    },
  },
  data(){
    return{
      Constants: Constants,
      moment: moment,
      loading: false,
      clientInvoice: null
    }
  },
  methods:{
    async getLastClientInvoice(){
      let invoiceNumber;
      let res = await this.$apollo.query({
        query: GET_LAST_CLIENT_INVOICE,
        variables:{ startDate: moment().format('YYYY-01-01T00:00:00+05:30') },       /* Last Invoice of current year */
        fetchPolicy: "network-only"
      });
      if(res.data.clientInvoices.length) invoiceNumber = incrementClientInvoiceNumber(res.data.clientInvoices[0].invoiceNumber);
      else invoiceNumber = 'TL'+moment().format('YY')+' - 000001';
      return invoiceNumber;
    },
    confirmAcceptAction(){
      let status, invoiceNumber, titleText;
      if(this.clientInvoice.statusId === Constants.ClientInvoiceStatus.PendingForApproval) {
        status = Constants.ClientInvoiceStatus.Unpaid; titleText = 'Client';
      } else if(this.clientInvoice.statusId === Constants.ClientInvoiceStatus.PendingForCancel){
        status = Constants.ClientInvoiceStatus.Canceled; titleText = 'Canceled Client';
      }
      this.$Modal.confirm({
        title: 'Confirm Approval Request',
        content: `<p>Are you Sure, you want to approve ?</p><p style="margin: 4px 0 0 0; font-size: 14px">Approving this request will move invoice to ${titleText} Invoices module</p>`,
        onOk: async () => {
          this.loading = true;
          if(!this.clientInvoice.invoiceNumber && status === Constants.ClientInvoiceStatus.Unpaid) invoiceNumber = await this.getLastClientInvoice();
          this.updateClientInvoiceStatus(status, invoiceNumber);
        },
        onCancel: () => {}
      })
    },
    async updateClientInvoiceStatus(status, invoiceNumber){
      /* Also generate invoice-number & add invoice date */
      let obj = {statusId : status, updatedBy:user.id};
      if(invoiceNumber) obj = { ...obj, invoiceNumber, invoiceDate:moment() };
      await this.updateRecord(this.clientInvoiceId, obj, 'clientInvoices');
      this.$Message.success('Client Invoice updated successfully!');
      this.loading = false;
      this.closeDialog();
    },
    closeDialog(){
      this.$refs['charges-summary-comp'].resetCharges();
      this.$emit('update:clientInvoiceId', null);
      this.$emit('update:dialog', false);
    }
  }
}
</script>

<style scoped>
.drawer-footer{
  position: fixed;
  bottom: 20px;
  width: 100%;
  background: #fff;
  border-top: 1px solid #e8eaec;
  padding: 12px;
  margin: 0 0 -20px -16px;
  z-index: 4;
}
.close-btn{
  margin-left: 10px;
}
</style>


